/* eslint-disable jsx-a11y/anchor-is-valid */

import { Component } from "react";

import Tooltip from "../../components/ToolTip";
import { ActivityLogConsumer } from "../../context/activity-log-context";
import FormatUtils from "../../utils/formatUtils";
import { timeSince } from "../../utils/utils";
import NotificationsModal from "../../components/NotificationsModal";

import "../../styles/activityLog.scss";

export default class ActivityLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPopupVisible: false,
    };
  }

  toggleModal = (event) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }

    this.setState({ isPopupVisible: !this.state.isPopupVisible });
  }

  render() {
    let quoteId = this.props.quoteId;

    return (
      <ActivityLogConsumer>
        {(contextState) => {
          const notifications = contextState.getQuoteNotifications(quoteId);
          const hasUnread = notifications.some((n) => !n.Read);
          const isNotifications = notifications.length > 0;
          return (
            <div className="activity-log">
              {this.state.isPopupVisible ? (
                <NotificationsModal
                  popupText={
                    hasUnread ? "mark ALL as read" : "mark ALL as unread"
                  }
                  contextState={contextState}
                  quoteId={quoteId}
                  popupYesAction={async () => {
                    await contextState.readQuoteNotifications(
                      quoteId,
                      hasUnread
                    );
                    this.toggleModal();
                  }}
                  popupNoAction={this.toggleModal}
                />
              ) : (
                ""
              )}
              <div className="activity-log-list">
                <div className={!isNotifications ? "empty" : ""}>
                  {isNotifications
                    ? notifications.map((notification) => (
                        <ActivityItem
                          {...notification}
                          key={notification.Key}
                        />
                      ))
                    : "There are no notifications"}
                </div>
                <a
                  draggable="false"
                  className="activity-log-mark-read"
                  disabled={
                    contextState.getQuoteUnreadNotificationsCount(quoteId) < 1
                  }
                  href="/"
                  onClick={this.toggleModal}
                >
                  {`Mark all ${hasUnread ? "" : "un"}read`}
                </a>
              </div>
            </div>
          );
        }}
      </ActivityLogConsumer>
    );
  }
}

const ActivityItem = ({
  Read,
  DisplayName,
  EventType,
  Hint,
  EventDate,
  Key,
  isExpired,
}) => {
  let { statusBg, fontColor } = FormatUtils.getStatusStyle(
    EventType,
    isExpired
  );

  let hints = Hint.split("•");
  let hintMainText = hints[0].split(/[ ]{2,}/);
  hints.shift();

  let hintText = (
    <div>
      <span style={{ fontWeight: "700" }}>{hintMainText[0]}</span>
      <br />
      <br />
      {hintMainText.map((value, index) => {
        if (index === 0) return null;

        return (
          <div key={index}>
            {index > 1 ? <br /> : ""}
            {value}
          </div>
        );
      })}
      <br /> {hints.length > 0 && <br />}
      {hints.map((h, index) => {
        return (
          <div style={{ paddingLeft: "10px" }} key={Key + index}>
            {"•" + h}
          </div>
        );
      })}
    </div>
  );

  return (
    <>
      <ActivityLogConsumer>
        {(contextState) => {
          return (
            <div
              className="activity-item"
              onClick={() => contextState.readNotification(Key, !Read)}
            >
              <div className={`red-dot${Read ? " read" : ""}`} />
              <div className={"activity-item-message"}>
                <div
                  className="activity-item-message-text"
                  style={{ backgroundColor: statusBg, color: fontColor }}
                >
                  {DisplayName}
                </div>
                <Tooltip id={Key}>{Hint ? hintText : ""}</Tooltip>
              </div>
              <div className="activity-item-age">{`${
                timeSince(new Date(EventDate)) || ""
              } ago`}</div>
            </div>
          );
        }}
      </ActivityLogConsumer>
    </>
  );
};
